import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';

export default function ForgotPasswordPage() {
  const [username, setUsername] = useState('');
  const [msg, setMsg] = useState('');
  const [isErr, setIsErr] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault(); setLoading(true);
    try {
      const { data } = await api.post('/auth/forgot_password.php', { username });
      setMsg(data.message || data.error); setIsErr(!data.success);
    } catch { setMsg('Network error.'); setIsErr(true); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'linear-gradient(135deg,#0f2544 0%,#1a3a6b 50%,#0d9488 100%)', padding:16 }}>
      <div style={{ width:'100%', maxWidth:380 }}>
        <div style={{ background:'#fff', borderRadius:18, padding:'32px 28px', boxShadow:'0 20px 60px rgba(0,0,0,.25)' }}>
          <Link to="/" style={{ color:'var(--text2)', fontSize:13, textDecoration:'none', display:'flex', alignItems:'center', gap:5, marginBottom:18 }}>← Back to login</Link>
          <h2 style={{ fontSize:17, fontWeight:700, color:'var(--navy)', marginBottom:6 }}>Forgot Password</h2>
          <p style={{ color:'var(--text2)', fontSize:13, marginBottom:20 }}>Enter your username and the administrator will be notified to reset your password.</p>
          {msg
            ? <div style={{ padding:'12px 16px', borderRadius:8, fontSize:13, fontWeight:500, background: isErr ? '#fef2f2' : '#f0fdf4', border: `1px solid ${isErr ? '#fca5a5' : '#86efac'}`, color: isErr ? '#b91c1c' : '#15803d' }}>{msg}</div>
            : (
              <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:14 }}>
                <div>
                  <label className="lbl">Username</label>
                  <input className="input" value={username} onChange={e => setUsername(e.target.value)} placeholder="Your username" required />
                </div>
                <button type="submit" className="btn btn-primary" disabled={loading} style={{ width:'100%', justifyContent:'center' }}>
                  {loading ? 'Sending…' : 'Send Reset Request'}
                </button>
              </form>
            )
          }
        </div>
      </div>
    </div>
  );
}
